import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { getPaginationMap } from '../../../utils/ApolloGraphqlUtil';

const SUPERLINK_VIEW = gql`
  query superLink($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      superLink(id: $id) {
        id
        name
      }
    }
  }
`;

const GET_LIST_FILE_IMPORT_SUPERLINK = gql`
  query(
    $accountId: ID!
    $superLinkId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: RespondentImportFilter
    $sort: RespondentImportSortSpecifier
  ) {
    account(id: $accountId) {
      superLink(id: $superLinkId) {
        id
        respondentImports(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
          edges {
            node {
              id
              fileName
              status
              createdOn
              updatedOn
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          totalCount
          indexFrom
          indexTo
        }
      }
    }
  }
`;

export const listFileImportQuery = graphql(GET_LIST_FILE_IMPORT_SUPERLINK, {
  options: ({ paginationFilter, match, currentAccount }) => {
    const {
      pageSize, query, cursorEnd, pageSizeLast, cursorStart, orderBy, orderDir,
    } = paginationFilter;
    const sort = orderBy || orderDir ? { sortBy: orderBy, sortDir: orderDir } : null;
    const { superLinkId } = match.params;
    return {
      variables: {
        accountId: currentAccount,
        superLinkId,
        first: pageSize,
        after: cursorEnd,
        last: pageSizeLast,
        before: cursorStart,
        filter: {
          query,
        },
        sort,
      },
      fetchPolicy: 'network-only',
    };
  },
  props: ({ data, ownProps }) => {
    const { superLink, fetchMore } = data;
    const { pageSize } = ownProps.paginationFilter;
    const { respondentImports } = superLink || { respondentImports: [] };
    return {
      data: {
        ...data,
        superLink: {
          ...superLink,
          respondentImports,
        },
        fetchMoreEntries: direction => fetchMore({
          variables: {
            pagination: getPaginationMap(respondentImports.pageInfo, pageSize)[direction],
          },
          updateQuery: (previousResult, { fetchMoreResult }) => fetchMoreResult,
        }),
      },
    };
  },
});

export const superlinkMetaDataQuery = graphql(SUPERLINK_VIEW, {
  name: 'viewSuperlink',
  options: (props) => {
    const { currentAccount, match } = props;
    const { superLinkId } = match.params;
    return {
      variables: {
        accountId: currentAccount,
        id: superLinkId,
      },
    };
  },
});
